import { all, fork } from "redux-saga/effects";

import adminSession from "./adminSession";
import assessmentSession from "./assessmentSession";
import botpressSession from "./botpressSession";
import creatorSession from "./creatorSession";
import onboardingSession from "./onboardingSession";
import partnerSession from "./partnerSession";
import patientSession from "./patientSession";
import providerSession from "./providerSession";
import userSession from "./userSession";

const sagas = [
  adminSession,
  onboardingSession,
  userSession,
  patientSession,
  assessmentSession,
  partnerSession,
  providerSession,
  creatorSession,
  botpressSession,
];

export default function* rootSaga() {
  yield all(sagas.map(saga => fork(saga)));
}
